import Action from "csi/def/Action";
import { Field } from "csi/def/Field";
import Relationship from "csi/def/Relationship";
import ViewRef from "csi/def/ViewRef";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import { REVISION_APPROVED, REVISION_DRAFT, REVISION_PENDING } from "csi/reflection/reflectionConstants";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import resolver from "csi/resolver";
import { Context } from "csi/def/Context";

// additional fields
const COPIED_FROM_BOM = "CopiedFromBOM";
const COPIED_FROM_BOM_REVISION = "CopiedFromBOMRev";
const REFRESH_FROM_REVISION = "RefreshFromRevision";
const COPIED_FROM_REVISION_STATE = "CopiedFromBOMRevisionState";

// additional view
const RECIPE_REVISIONS_VIEW = "FoodLabelNewFromRecipeRevisions";
const FOOD_BOM_REVISIONS_VIEW = "FoodLabelNewFromFoodBOMRevisions";

const RefreshLabelItemsForm = declare(Widget, {

	/**
	 * @override
	 * Add Go to Dialog to RefreshFromRevision field
	 */
	getFieldStore: function (field: Field, value: any) {
		if (field.getControlName() === COPIED_FROM_REVISION_STATE) {
			const copiedFromBomRevURL = this.getFieldValue(COPIED_FROM_BOM_REVISION, true);
			if (!xml.isEmptyURL(copiedFromBomRevURL) ) {
				return this.inherited(arguments);
			}
			return null;
		}
		if (field.getControlName() === REFRESH_FROM_REVISION) {
			const ctx = this.getContext();
			const copiedFromBomURL = this.getFieldValue(COPIED_FROM_BOM, true);
			const query = new Query().RefAttr("__Parent__", xml.OP_EQUALS, copiedFromBomURL);
			query.Or().Attr("State", xml.OP_EQUALS, REVISION_DRAFT)
				.Attr("State", xml.OP_EQUALS, REVISION_APPROVED)
				.Attr("State", xml.OP_EQUALS, REVISION_PENDING);

			// create relationship for RecipeRevision dropdown
			const copiedFromBomNode = resolver.resolveNode(copiedFromBomURL, true);
			const isFoodBOM = copiedFromBomNode.$Type === "FoodBOM";
			const rel = lang.mixin(new Relationship(), {
				m_typeNode: isFoodBOM ? "FoodBOMRevision": "RecipeDataSheetRevision",
				m_query: query,
			});

			const store = ctx.view.createHeadingNamesStore(ctx, field, null, rel);

			// create view for goto dialog
			store.action = lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: isFoodBOM ? FOOD_BOM_REVISIONS_VIEW : RECIPE_REVISIONS_VIEW,
					m_url: copiedFromBomURL,
				}),
				m_tooltip: locale.resource("GoToDialogPopup_Title", [locale.resource(REFRESH_FROM_REVISION)]),
			});
			return store;
		}
		return this.inherited(arguments);
	},
	
	/**
	 * @override
	 * Add to disable Copied From Revision State field when dropdown is empty
	 */
	_buildField(ctx: Context, field: Field, tr: HTMLElement, tdControl?: HTMLElement) {
		this.inherited(arguments);

		if (field.getControlName() === COPIED_FROM_REVISION_STATE && !this.getFieldStore(field, null)) {
			this.setFieldDisabled(field, true);
		}
	},
});

export = RefreshLabelItemsForm;